'use client';
import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import dynamic from 'next/dynamic';
import { Toast } from 'flowbite-react';
import Image from 'next/image';
import Link from 'next/link';
import { addIntoLocalStorage, getLocalItem, isEmpty } from '@/utils/common-helpers';
import BorderEdge from './common/border-edge';
import { usePathname } from 'next/navigation';

const FooterContactInfo = dynamic(() => import('@/components/footer-contact-info'));

const FooterBasics = dynamic(() => import('@/components/footer-basics'));

const Footer: FC<Record<string, never>> = function () {
    const location = usePathname();

    const [showToast, setShowToast] = useState(false);
    const [mounted, setMounted] = useState(false);
    const [showMeeting, setShowMeeting] = useState(false);

    const props = { showToast, setShowToast };

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!mounted) return;

        Aos.init({
            offset: 100,
        });
        setShowToast(isEmpty(getLocalItem('co_allowed')));
    }, [mounted]);

    useEffect(() => {
        if (location === '/lets-meet-usa') {
            setShowMeeting(false);
        } else {
            setShowMeeting(true);
        }
    }, [location]);

    const closeMeeting = () => {
        setShowMeeting(false);
    };

    return (
        <>
            <footer className="section">
                <BorderEdge color="text-primary" />
                <FooterContactInfo />
                <FooterBasics />
                {props.showToast && (
                    // cookie should be in left side of the screen
                    <Toast className="fixed bottom-6 start-6 p-0 z-10 bg-transparent shadow-none cookie-toast">
                        <div className="cookie">
                            <p className="fs-sm">
                                We use cookies to ensure that we give you the best experience on our website. Learn about our{' '}
                                <Link href="/privacy-policy" target="_blank" className="font-semibold">
                                    Privacy policy
                                </Link>{' '}
                                here.
                            </p>
                            <div className="relative">
                                <div>
                                    <button
                                        className="btn btn-outline-primary dark:border-white dark:hover:!border-white dark:text-white dark:hover:text-white fs-sm mt-4"
                                        aria-label="Allow Cookies"
                                        onClick={() => {
                                            addIntoLocalStorage('co_allowed', 'true');
                                            props.setShowToast(!props.showToast);
                                        }}
                                    >
                                        Okay
                                    </button>
                                </div>
                                <Image
                                    src="/img/cookie@2x.webp"
                                    className="img-fluid cookie-img"
                                    alt="cookie"
                                    title="cookie"
                                    width={148}
                                    height={82}
                                />
                            </div>
                        </div>
                    </Toast>
                )}

                {showMeeting && (
                    <div className="fixed bottom-6 start-6 p-0 z-10  cookie-toast-two max-w-[180px]   rounded-10 ">
                        <button
                            className="absolute top-[-15px] left-[-11px] z-30 bg-textcolor rounded-full px-1 pb-1 pt-[2.3px] cookie-toast-border"
                            onClick={() => closeMeeting()} // Assuming this hides the toast
                            aria-label="Close"
                        >
                            <Image
                                src="/img/icons/tabler-icon-x.svg" // Replace with the correct path to your image
                                alt="Close"
                                width={18}
                                height={18}
                            />
                        </button>
                        <div className="cookie-two  overflow-hidden p-[15px] rounded-10 h-[270px] video-container relative">
                            {/* Close (Cross) button */}

                            {/* Background video */}

                            <video className="absolute top-0 left-0 w-full h-full object-cover" autoPlay muted loop playsInline>
                                <source src="/media/usa-video-popup.mp4" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                            <div className="overlay"></div>

                            {/* Cookie text and content */}
                            <h4 className="text-[28px] leading-[32px] relative font- z-20 text-white pb-[5px] font-bold proximanovacond">
                                Strategic Discussions
                            </h4>
                            <p className="text-base font-semibold pb-[5px] relative z-20 text-white mb-0">
                                6th May 2026 to 27th June 2026
                            </p>
                            <p className="text-base font-semibold pb-[50px] relative z-20 text-white mb-0">
                                Meet Our Experts in the USA
                            </p>
                            <div className="relative z-20">
                                <div>
                                    <Link
                                        className="btn btn-primary whitespace-nowrap w-[150px] text-[15px] py-[10px] px-[22px]"
                                        aria-label="Allow Cookies"
                                        href="https://www.moweb.com/lets-meet-usa"
                                    >
                                        Book a Meeting
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </footer>
        </>
    );
};

export default Footer;
